'use client'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { dltHsnCode, getHsnCode, postHsnCode, updateHsnCode } from '../../services'



export default function HsnCode() {
    const [hsnList, setHsnList] = useState([])
    const [loading, setLoading] = useState(false)

    const [form, setForm] = useState({
        id: null,
        code: '',
        percent: ''
    })

    /* ---------------- FETCH ---------------- */
    const fetchHsn = async () => {
        try {
            const res = await getHsnCode()
            console.log(res)
            setHsnList(res || [])
        } catch (err) {
            toast.error('Failed to fetch HSN codes')
        }
    }

    useEffect(() => {
        fetchHsn()
    }, [])

    /* ---------------- CREATE / UPDATE ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)

        try {
            const payload = {
                code: form.code,
                percent: form.percent
            }
            if (form.id) {

                // UPDATE
                await updateHsnCode(form.id, payload)
                toast.success('HSN updated')
            } else {
                // CREATE
                await postHsnCode(payload)
                toast.success('HSN created')
            }

            setForm({ id: null, code: '', percent: '' })
            fetchHsn()
        } catch (err) {
            toast.error('Operation failed')
        } finally {
            setLoading(false)
        }
    }

    /* ---------------- EDIT ---------------- */
    const handleEdit = (item) => {
        setForm({
            id: item.id,
            code: item.code,
            percent: item.percent
        })
    }

    /* ---------------- DELETE ---------------- */
    const handleDelete = async (id) => {


        try {
            await dltHsnCode(id)
            toast.success('HSN deleted')
            fetchHsn()
        } catch {
            toast.error('Delete failed')
        }
    }

    return (
        <div className="p-6 max-w-4xl mx-auto">
            <h1 className="text-2xl font-bold mb-6">HSN Code Management</h1>

            {/* FORM */}
            <form
                onSubmit={handleSubmit}
                className="grid grid-cols-1 md:grid-cols-3 gap-4 bg-white p-4 rounded-lg shadow mb-8"
            >
                <input
                    type="text"
                    placeholder="HSN Code"
                    className="border rounded px-3 py-2"
                    value={form.code}
                    onChange={(e) => setForm({ ...form, code: e.target.value })}
                    required
                />

                <input
                    type="number"
                    step="0.01"
                    placeholder="percent %"
                    className="border rounded px-3 py-2"
                    value={form.percent}
                    onChange={(e) => setForm({ ...form, percent: e.target.value })}
                    required
                />

                <button
                    type="submit"
                    className="bg-green-700 text-white rounded px-4 py-2 hover:bg-green-900 transition"
                    disabled={loading}
                >
                    {form.id ? 'Update' : 'Create'}
                </button>
            </form>

            {/* TABLE */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="text-left p-3">HSN Code</th>
                            <th className="text-left p-3">Percent %</th>
                            <th className="text-right p-3">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {hsnList.length === 0 && (
                            <tr>
                                <td colSpan={3} className="text-center p-6 text-gray-500">
                                    No HSN codes found
                                </td>
                            </tr>
                        )}

                        {hsnList.map((item) => (
                            <tr key={item.id} className="border-t">
                                <td className="p-3">{item.code}</td>
                                <td className="p-3">{item.percent}%</td>
                                <td className="p-3 text-right space-x-2">
                                    <button
                                        onClick={() => handleEdit(item)}
                                        className="px-3 py-1 text-xs bg-yellow-100 text-yellow-700 rounded"
                                    >
                                        Edit
                                    </button>
                                    {/* <button
                                        onClick={() => handleDelete(item.id)}
                                        className="px-3 py-1 text-xs bg-red-100 text-red-700 rounded"
                                    >
                                        Delete
                                    </button> */}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
